// extracted by mini-css-extract-plugin
module.exports = {"row":"dfb2370c6125a196d177d0d69012a7c8-less"};